module.exports = __webpack_public_path__ + "static/media/login-hero-image.1f9b2241.png";